import { render, staticRenderFns } from "./insuredValueInput.vue?vue&type=template&id=0d22c313&"
import script from "./insuredValueInput.vue?vue&type=script&lang=js&"
export * from "./insuredValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports